import Vue from 'vue';
import Router, { Route } from 'vue-router';

import {
  CmgHome,
  CmgSignIn,
  CmgMealBuilderPage,
  CmgGroupOrderCreatePage,
  CmgPaymentsAndGiftCardsPage,
  CmgCheckoutPage,
  CmgGroupOrderJoin,
  CmgGroupOrderMenu,
  CmgGroupOrderError,
  CmgGroupOrderConfirmation,
  CmgOrderConfirmationPage,
  CmgCreateAccountPage,
  CmgRewards,
  CmgRewardsExchange,
  CmgRewardsExtras,
  CmgRewardsPointsHistory,
  CmgPersonalAndPreferencesPage,
  CmgRetroCreditPage,
  CmgRecentsAndFavoritesPage,
  CmgPasswordResetRequestPage,
  CmgPasswordResetPage,
  CmgPageNotFound,
  CmgOffline,
  CmgSustainabilityStatsPage,
  CmgRewardsAchievements,
  CmgNutritionCalculatorPage,
  CmgNutritionCalculatorMealBuilderPage,
  CmgIngredientsLandingPage
} from './views';
Vue.use(Router);

export enum Routes {
  Home = 'home',
  Order = 'order',
  SignIn = 'sign-in',
  VendorSignIn = 'vendor-sign-in',
  MealBuilder = 'meal-builder',
  MealBuilderEdit = 'meal-builder-edit',
  PcmMealBuilderEdit = 'pcm-meal-builder-edit',
  GroupOrderMealBuilder = 'group-order-meal-builder',
  GroupOrderMealBuilderEdit = 'group-order-meal-builder-edit',
  GroupOrderPcmMealBuilderEdit = 'group-order-pcm-meal-builder-edit',
  GroupOrderCreate = 'group-order-create',
  GroupOrderJoin = 'group-order-join',
  GroupOrderMenu = 'group-order-menu',
  GroupOrderError = 'group-order-error',
  GroupOrderConfirmation = 'group-order-confirmation',
  PaymentsAndGiftCards = 'payments-and-gift-cards',
  Checkout = 'checkout',
  OrderConfirmation = 'order-confirmation',
  CreateAccount = 'create-account',
  VendorCreateAccount = 'vendor-create-account',
  Rewards = 'rewards',
  RewardsAchievements = 'rewards-achievements',
  RewardsExchange = 'rewards-exchange',
  RewardsExtras = 'rewards-extras',
  RewardsPointsHistory = 'rewards-points-history',
  EditAccount = 'edit-account',
  RetroCredit = 'retro-credit',
  RecentsAndFavorites = 'recents-and-favorites',
  PasswordResetRequestPage = 'password-reset-request-page',
  VendorPasswordResetRequestPage = 'vendor-password-reset-request-page',
  PasswordResetPage = 'password-reset-page',
  PageNotFound = 'page-not-found',
  FindAChipotle = 'find-a-chipotle',
  Offline = 'offline',
  CmgSustainabilityStatsPage = 'real-foodprint',
  NutritionCalculatorPage = 'nutrition-calculator',
  NutritionCalculcatorMealBuilder = 'nutrition-calculator-meal-builder',
  IngredientsLandingPage = 'ingredients-landing-page',
  IngredientsLandingPageIngredientSelect = 'ingredients-landing-page-ingredient-select',
  GuacModeSignIn = 'guacmodeverified'
}

const SIGN_IN_PATH = '/order/sign-in';

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,

  // Scroll to top of the page on a route change
  // TODO: Consider removing. Using it as stated in documentation
  // does not scroll to the top like they say it does.
  scrollBehavior(to, from) {
    if( to?.hash ) {
      return;
    }
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({x: 0, y: 0});
      }, 100);
    });
  },

  routes: [
    {
      path: '/',
      name: Routes.Home,
      component: CmgHome,
      meta: {
        title: 'Chipotle — Order Now',
      },
    },
    {
      path: '/home',
      redirect: { name: Routes.Home },
    },
    {
      // For AEM editor support
      path: '/content/chipotle*',
      component: CmgHome,
    },
    {
      path: '/ingredients',
      name: Routes.IngredientsLandingPage,
      component: CmgIngredientsLandingPage,
      meta: {
        title: 'Chipotle — Ingredients List',
      },
    },
    {
      path: '/ingredients/:ingredientName',
      name: Routes.IngredientsLandingPageIngredientSelect,
      component: CmgIngredientsLandingPage,
      meta: {
        title: 'Chipotle — Ingredients List',
      },
    },
    {
      path: '/order',
      name: Routes.Order,
      component: CmgHome,
      meta: {
        title: 'Chipotle — Order Now',
      },
    },
    {
      path: SIGN_IN_PATH,
      name: Routes.SignIn,
      component: CmgSignIn,
      meta: {
        title: 'Chipotle — Sign In',
      },
    },
    {
      path: '/order/vendor/sign-in',
      name: Routes.VendorSignIn,
      component: CmgSignIn,
      meta: {
        title: 'Chipotle - Vendor Sign In',
        isFullPageLayout: true,
      },
    },
    {
      path: '/order/build/:groupName',
      name: Routes.MealBuilder,
      component: CmgMealBuilderPage,
      meta: {
        title: 'Chipotle — Build Your Order',
      },
    },
    {
      path: '/order/build/edit/:mealId',
      name: Routes.MealBuilderEdit,
      component: CmgMealBuilderPage,
      meta: {
        title: 'Chipotle — Edit Your Order',
      },
    },
    {
      path: '/order/build/edit/pcm/:pcmId',
      name: Routes.PcmMealBuilderEdit,
      component: CmgMealBuilderPage,
      meta: {
        title: 'Chipotle — Edit Your Order',
      },
    },
    {
      path: '/order/group/build/:groupName',
      name: Routes.GroupOrderMealBuilder,
      component: CmgMealBuilderPage,
      meta: {
        title: 'Chipotle — Build Your Order',
      },
    },
    {
      path: '/order/group/build/edit/:mealId',
      name: Routes.GroupOrderMealBuilderEdit,
      component: CmgMealBuilderPage,
      meta: {
        title: 'Chipotle — Edit Your Order',
      },
    },
    {
      path: '/order/group/build/edit/pcm/:pcmId',
      name: Routes.GroupOrderPcmMealBuilderEdit,
      component: CmgMealBuilderPage,
      meta: {
        title: 'Chipotle — Edit Your Order',
      },
    },
    {
      path: '/order/group/create',
      name: Routes.GroupOrderCreate,
      component: CmgGroupOrderCreatePage,
      meta: {
        title: 'Chipotle — Create a Group Order',
      },
    },
    {
      path: '/order/group/join/:groupOrderId',
      name: Routes.GroupOrderJoin,
      component: CmgGroupOrderJoin,
      meta: {
        title: 'Chipotle — Join the Group Order',
      },
    },
    {
      path: '/order/group/menu',
      name: Routes.GroupOrderMenu,
      component: CmgGroupOrderMenu,
      meta: {
        title: 'Chipotle — Menu',
      },
    },
    {
      path: '/order/group/error/:type',
      name: Routes.GroupOrderError,
      component: CmgGroupOrderError,
      meta: {
        title: 'Chipotle — Error',
      },
    },
    {
      path: '/order/group/confirmation',
      name: Routes.GroupOrderConfirmation,
      component: CmgGroupOrderConfirmation,
      meta: {
        title: 'Chipotle — Order Confirmation',
      },
    },
    {
      path: '/nutrition-calculator/:topLevelName',
      name: Routes.NutritionCalculcatorMealBuilder,
      component: CmgNutritionCalculatorMealBuilderPage,
      meta: {
        title: 'Chipotle — Nutrition Information',
      },
    },
    {
      path: '/order/payments-and-gift-cards',
      name: Routes.PaymentsAndGiftCards,
      component: CmgPaymentsAndGiftCardsPage,
      meta: {
        title: 'Chipotle — Payments',
      },
    },
    {
      path: '/order/checkout',
      name: Routes.Checkout,
      component: CmgCheckoutPage,
      meta: {
        title: 'Chipotle — Checkout',
      },
    },
    {
      path: '/order/checkout/:orderId/confirmation',
      name: Routes.OrderConfirmation,
      component: CmgOrderConfirmationPage,
      meta: {
        title: 'Chipotle — Order Confirmation',
      },
    },
    {
      path: '/order/create-account',
      name: Routes.CreateAccount,
      component: CmgCreateAccountPage,
      meta: {
        title: 'Chipotle — Create an Account',
      },
    },
    {
      path: '/order/vendor/create-account',
      name: Routes.VendorCreateAccount,
      component: CmgCreateAccountPage,
      meta: {
        title: 'Chipotle — Vendor Create an Account',
        isFullPageLayout: true,
      },
    },
    {
      path: '/order/rewards',
      name: Routes.Rewards,
      component: CmgRewards,
      meta: {
        title: 'Chipotle — Rewards',
      },
    },
    {
      path: '/order/rewards/achievements',
      name: Routes.RewardsAchievements,
      component: CmgRewardsAchievements,
      meta: {
        title: 'Chipotle — Rewards Achievements',
      },
    },
    {
      path: '/order/rewards/exchange',
      name: Routes.RewardsExchange,
      component: CmgRewardsExchange,
      meta: {
        title: 'Chipotle — Rewards Exchange',
      },
    },
    {
      path: '/order/rewards/extras',
      name: Routes.RewardsExtras,
      component: CmgRewardsExtras,
      meta: {
        title: 'Chipotle — Rewards Extras',
      },
    },
    {
      path: '/order/rewards/points/history',
      name: Routes.RewardsPointsHistory,
      component: CmgRewardsPointsHistory,
      meta: {
        title: 'Chipotle — Rewards History',
      },
    },
    {
      path: '/order/edit-account',
      name: Routes.EditAccount,
      component: CmgPersonalAndPreferencesPage,
      meta: {
        title: 'Chipotle — Edit Account',
      },
    },
    {
      path: '/order/retro-credit',
      name: Routes.RetroCredit,
      component: CmgRetroCreditPage,
      meta: {
        title: 'Chipotle — Points Request',
      },
    },
    {
      path: '/order/favorites-and-recents',
      name: Routes.RecentsAndFavorites,
      component: CmgRecentsAndFavoritesPage,
      meta: {
        title: 'Chipotle — Favorite & Recent Orders',
      },
    },
    {
      path: '/order/password-reset/enter-email',
      name: Routes.PasswordResetRequestPage,
      component: CmgPasswordResetRequestPage,
      meta: {
        title: 'Chipotle — Password Reset Request',
      },
    },
    {
      path: '/order/vendor/password-reset',
      name: Routes.VendorPasswordResetRequestPage,
      component: CmgPasswordResetRequestPage,
      meta: {
        title: 'Chipotle — Vendor Password Reset',
        isFullPageLayout: true,
      },
    },
    {
      path: '/order/password-reset/submit-password',
      name: Routes.PasswordResetPage,
      component: CmgPasswordResetPage,
      meta: {
        title: 'Chipotle — Enter New Password',
      },
    },
    {
      path: '/order/find-a-chipotle',
      name: Routes.FindAChipotle,
      component: CmgHome,
      meta: {
        title: 'Chipotle — Order Now',
      },
    },
    {
      path: '/offline',
      name: Routes.Offline,
      component: CmgOffline,
      meta: {
        title: 'Chipotle — Offline',
      },
    },
    {
      path: '/order/real-foodprint',
      name: Routes.CmgSustainabilityStatsPage,
      component: CmgSustainabilityStatsPage,
      meta: {
        title: 'Chipotle — Real Foodprint',
      },
    },
    {
      path: '/nutrition-calculator',
      name: Routes.NutritionCalculatorPage,
      component: CmgNutritionCalculatorPage,
      meta: {
        title: 'Chipotle — Nutrition Calculator',
      },
    },
    {
      path: '/guacmodeverified',
      name: Routes.GuacModeSignIn,
      component: CmgHome,
      meta: {
        title: 'Chipotle — GuacMode Sign In',
      },
    },
    {
      path: '*',
      name: Routes.PageNotFound,
      component: CmgPageNotFound,
      meta: {
        title: 'Chipotle — Page Not Found',
      },
    },
  ],
});

export function isGroupOrderRoute(route: Route): boolean {
  return route.path.indexOf('/group/') >= 0;
}

export function isNutritionCalculatorRoute(route: Route): boolean {
  return route.path.indexOf('/nutrition-calculator') >= 0;
}

export function doesRouteRequireGroupOrderRestaurant(route: Route): boolean {
  return (
    route.name == Routes.GroupOrderMenu ||
    route.name == Routes.GroupOrderMealBuilder ||
    route.name == Routes.GroupOrderMealBuilderEdit ||
    route.name == Routes.GroupOrderPcmMealBuilderEdit ||
    route.name == Routes.GroupOrderConfirmation
  );
}

export function getSignInPath(redirectPath: string): string {
  return `${SIGN_IN_PATH}?path=${redirectPath}`;
}
